export default "__VITE_ASSET__BoGbFIsG__"